export const LEVEL_PERIMETER_ROUTE = 'perimeter'
export const LEVEL_ROUTE = 'perimeter-level'
export const HOME_ROUTE = 'Home'
export const PAGE_NOT_FOUND_ROUTE = 'PageNotFound'

// Completed Tasks
export const COMPLETED_TASKS_LIST_ROUTE_NAME = 'completed-tasks-list'
